/* eslint-disable react-hooks/exhaustive-deps */
import { Grid } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Controls } from '../../components/controls/Controls';
import { Form, useForm } from '../../components/useForm';
import { setIsDirtyMateriales } from '../../redux/ducks/dirtyMateriales';

export default function MaterialesForm(props) {
    const isDirtyMateriales = useSelector((state) => state.dirtyMateriales.isDirtyMateriales);
    const initialFieldValues = {
        id: 0,
        numeroParte: '',
        nombreMaterial: '',
        proveedor: '',
        precioUnitario: 0,
        facturaProveedor: '',
        fechaCompra: null,
        cantidad: 0,
        concepto: '',
    };
    const [disableButton, setDisableButton] = useState(false);
    const {
        values, setValues, errors, setErrors, handleInputChange, resetForm,
    } = useForm(
        initialFieldValues,
        true,
        // eslint-disable-next-line no-use-before-define
        validate,
    );

    function validate(fieldValues = values) {
        const temp = { ...errors };

        if ('fechaCompra' in fieldValues) {
            temp.fechaCompra = fieldValues.fechaCompra ? '' : 'Campo Requerido';
        }

        if ('numeroParte' in fieldValues) {
            temp.numeroParte = fieldValues.numeroParte ? '' : 'Campo Requerido';
        }
        if ('nombreMaterial' in fieldValues) {
            temp.nombreMaterial = fieldValues.nombreMaterial ? '' : 'Campo Requerido';
        }
        if ('cantidad' in fieldValues) {
            temp.cantidad = fieldValues.cantidad ? '' : 'Campo Requerido';
        }
        if ('proveedor' in fieldValues) {
            temp.proveedor = fieldValues.proveedor ? '' : 'Campo Requerido';
        }

        setErrors({
            ...temp,
        });

        if (fieldValues === values) {
            return Object.values(temp).every((x) => x === '');
        }
        return true;
    }

    const { addOrEdit, recordForEdit } = props;
    const dispatch = useDispatch();

    useEffect(() => {
        if (recordForEdit != null) {
            setValues({
                ...recordForEdit,
            });
        }
    }, [recordForEdit, setValues]);

    const handleSubmit = (e) => {
        setDisableButton(true);
        e.preventDefault();
        if (validate()) {
            addOrEdit(values, resetForm);
            dispatch(setIsDirtyMateriales(true));
        } else {
            setDisableButton(false);
        }
    };

    return (
        <Form onSubmit={handleSubmit}>
            <Grid container item xs={12}>
                <Grid item xs={6}>
                    <Controls.Input
                        error={errors.numeroParte}
                        label='Numero de Parte *'
                        name='numeroParte'
                        onChange={(e) => { handleInputChange(e); dispatch(setIsDirtyMateriales(true)); }}
                        value={values.numeroParte}
                    />
                    <Controls.Input
                        error={errors.nombreMaterial}
                        label='Nombre de Material *'
                        name='nombreMaterial'
                        onChange={(e) => { handleInputChange(e); dispatch(setIsDirtyMateriales(true)); }}
                        value={values.nombreMaterial}
                    />
                    <Controls.Input
                        error={errors.proveedor}
                        label='Proveedor *'
                        name='proveedor'
                        onChange={(e) => { handleInputChange(e); dispatch(setIsDirtyMateriales(true)); }}
                        value={values.proveedor}
                    />
                    <Controls.NumericInput
                        error={errors.precioUnitario}
                        label='Precio Unitario *'
                        name='precioUnitario'
                        onChange={(e) => { handleInputChange(e); dispatch(setIsDirtyMateriales(true)); }}
                        value={values.precioUnitario}
                    />
                    <Controls.Input
                        error={errors.facturaProveedor}
                        label='Factura Proveedor *'
                        name='facturaProveedor'
                        onChange={(e) => { handleInputChange(e); dispatch(setIsDirtyMateriales(true)); }}
                        value={values.facturaProveedor}
                    />
                </Grid>
                <Controls.DatePicker
                    error={errors.fechaCompra}
                    label='Fecha de Compra *'
                    name='fechaCompra'
                    onChange={(e) => { handleInputChange(e); dispatch(setIsDirtyMateriales(true)); }}
                    value={values.fechaCompra}
                />
                <Grid item xs={6}>
                    <Controls.NumericInput
                        error={errors.cantidad}
                        inputProps={{
                            min: '0',
                            step: '1',
                            onKeyPress: (event) => {
                                if (!/[0-9]/.test(event.key)) {
                                    event.preventDefault();
                                }
                            },
                            onPaste: (event) => {
                                if (!/[0-9]/.test(event.clipboardData.getData('text'))) {
                                    event.preventDefault();
                                }
                            },
                        }}
                        label='Cantidad *'
                        name='cantidad'
                        onChange={(e) => { handleInputChange(e); dispatch(setIsDirtyMateriales(true)); }}
                        type='number'
                        value={values.cantidad}
                    />
                    <Controls.Input
                        error={errors.concepto}
                        label='Concepto *'
                        name='concepto'
                        onChange={(e) => { handleInputChange(e); dispatch(setIsDirtyMateriales(true)); }}
                        value={values.concepto}
                    />
                    <div>
                        <Controls.Button disabled={disableButton} text='Guardar' type='submit' />
                        <Controls.Button
                            color='default'
                            onClick={resetForm}
                            text='Reset'
                        />
                    </div>
                </Grid>
            </Grid>
        </Form>
    );
}
